module.exports = (value) ->
  if !value?
    return false

  if typeof value != 'object'
    return false

  Object.getPrototypeOf(value) in [null, Object.prototype]
